<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" style="cursor: pointer;" (click)="modalClose()"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  
  @if (sysProjectLoading) {
<div style="margin-bottom: 12px;">
    <b>Key:</b>
    <div class="badge">LEID - TAX CODE - ME - RPT.PD - CURR</div>
  </div>
}

  @if (sysProjectLoading) {
<div class="entitie-holder">
    @for (entity of entities; track $index; let i = $index) {
<div class="btn-group dropup pull-left" 
        
         [title]="entity.data.TAG_163J_DESC">
      <button type="button" class="btn btn-xs btn-default">
        {{ entity.data.LEID }} - {{ entity.data.CDR_NO }} - {{ entity.data.ME_CODE }} - {{ entity.data.REPORTING_PERIOD }} - {{ entity.data.FC }}
      </button>
      <button type="button" 
              (click)="removeEntity(i)" 
              class="btn btn-xs btn-danger" 
              aria-haspopup="true" 
              aria-expanded="false">
        <span class="fa fa-times"></span>
      </button>
    </div>
}
  </div>
}
  
  @if (tagProjectLoading) {
<div style="margin-bottom: 12px;">
    <b>Key:</b> 
    <div class="badge btn-info">SYSTEM CHART CODE - SYSTEM ACCOUNT - SYSTEM ACCOUNT DESC</div>
  </div>
}

  @if (tagProjectLoading) {
<div class="entitie-holder">
    @for (entity of entities; track $index; let i = $index) {
<div class="btn-group dropup pull-left" 
        
         [title]="entity.data.TAG_163J_DESC">
      <button type="button" class="btn btn-xs btn-default">
        {{ entity.data.SYS_CHART_CODE }} - {{ entity.data.SYS_ACCT }} - {{ entity.data.SYS_ACCT_DESC }}
      </button>
      <button type="button" 
              (click)="removeEntity(i)" 
              class="btn btn-xs btn-danger dropdown-toggle" 
              aria-haspopup="true" 
              aria-expanded="false">
        <span class="fa fa-times"></span>
      </button>
    </div>
}
  </div>
}
  
  @if (entities.length > 10) {
<div class="entitie-holder">
    <div>
      <label>Selected Entities Count: <span class="badge badge-pill badge-info">{{ entities.length }}</span></label>
    </div>
  </div>
}

  <div class="panel panel-default" style="margin-top:12px">
    <div class="panel-body">
      <div class="form-group">
        <div class="row">
          <div class="col-sm-5">
            <label for="project">Project</label>
            <div class="select-loader-container">
              <select id="project"
                      class="form-control"
                      name="project"
                      [(ngModel)]="project"
                      [disabled]="projectLoading"
                      required>
                <option value="">Please Select a Project</option>
                @for (p of projectList; track $index) {
<option 
                        [ngValue]="p">
                  {{ p.TAG_163J_DESC }}
                </option>
}
              </select>
              @if (projectLoading) {
<div class="loading-spinner">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" 
          type="button" 
          (click)="save()"
          [disabled]="crudLoading">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save
  </button>
  <button class="btn btn-warning btn-sm" 
          type="button" 
          (click)="cancel()">
    Cancel
  </button>
</div>
